const routes = Object.freeze({
  error: '/er-is-iets-misgegaan',
  frontOffice: '/start',
  nieuw: '/nieuw',
});

export default routes;
